// フォント定義リスト (既存の blade から移植 + 追加フォント)
export const FONT_LIST = [
    // --- 日本語フォント ---
    { id: 'anzu',           label: 'ひらがなカタカナ漢字Alph123', family: 'anzu',           weight: '' },
    { id: 'ranobepop',      label: 'ひらがなカタカナ漢字Alph123', family: 'ranobepop',      weight: '' },
    // 追加日本語フォント
    { id: 'tamanegiKaisho',   label: 'ひらがなカタカナ漢字Alph123', family: 'tamanegi-kaisho',     weight: '' },
    // --- 英字フォント ---
    { id: 'pacifico',       label: 'Alphabet123',  family: 'Pacifico',               weight: '' },
    { id: 'fredericka',     label: 'Alphabet123',  family: 'Fredericka the Great',   weight: '' },
    { id: 'greatVibes',     label: 'Alphabet123',  family: 'Great Vibes',            weight: '' },
    { id: 'shadowsIntoLight', label: 'Alphabet123', family: 'Shadows Into Light Two', weight: '' },
    { id: 'parisienne',     label: 'Alphabet123',  family: 'Parisienne',             weight: '' },
    { id: 'tangerine',      label: 'Alphabet123',  family: 'Tangerine',              weight: '700' },
    { id: 'robotoSlab',     label: 'Alphabet123',  family: 'Roboto Slab',            weight: '700' },
]

export const DEFAULT_FONT = FONT_LIST[0]
